import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Button, MenuItem, Avatar, Fab } from '@material-ui/core';
import { logout } from '../../actions/auth';
import {
	GRAY_HIGHLIGHT,
	WHITE_COLOR,
	BLACK_COLOR,
	BLUE,
} from '../../constants/color';
import { NavLink, useHistory } from 'react-router-dom';
import AppModal from './AppModal';
import Broadcast from '../messaging/Broadcast';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getNameAbbreviation } from '../../utils';
import AddBanner from '../messaging/AddBanner';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	drawer: {
		[theme.breakpoints.up('sm')]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	appBar: {
		[theme.breakpoints.up('sm')]: {
			width: `calc(100% - ${drawerWidth}px)`,
			marginLeft: drawerWidth,
		},
		backgroundColor: WHITE_COLOR,
	},

	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			display: 'none',
		},
	},
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		width: drawerWidth,
	},
	content: {
		flexGrow: 1,
	},
	title: {
		flexGrow: 1,
	},
	large: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	},
	fab: {
		position: 'absolute',
		backgroundColor: BLACK_COLOR,
		bottom: theme.spacing(2),
		marginLeft: 30,
		fontSize: 12,
		'&:hover': {
			backgroundColor: BLACK_COLOR,
		},
		fontWeight: 'bold',
		paddingLeft: 20,
		paddingRight: 20,
	},
}));

function AppDrawer(props) {
	const { container } = props;
	const classes = useStyles();
	const theme = useTheme();
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [openBroadcastModal, setOpenBroadcastModal] = React.useState(false);
	const [openBannerModal, setOpenBannerModal] = React.useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	const history = useHistory();

	const handleLogout = async () => {
		await history.push('/login');
		props.logout();
	};

	const links = [
		{ text: 'Dashboard', link: '/' },
		{ text: 'Users', link: '/users' },
		{ text: 'Verified Shops', link: '/verifiedshops' },
		{ text: 'BVN Users', link: '/bvnusers' },
	];

	const drawer = (
		<div>
			<div className={classes.toolbar}>
				<div
					style={{
						fontSize: 26,
						paddingTop: 14,
						width: '100%',
						height: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					hala<span style={{ color: GRAY_HIGHLIGHT }}>message</span>
				</div>
			</div>
			<Divider />
			<List
				onClick={() => {
					if (mobileOpen) handleDrawerToggle();
				}}
				style={{
					paddingLeft: 30,
					paddingTop: 25,
				}}
			>
				{links.map(({ text, link }, index) => (
					<NavLink
						to={link}
						key={index}
						activeStyle={{ color: BLUE }}
						exact
						style={{
							color: BLACK_COLOR,
							textDecoration: 'none',
						}}
					>
						<ListItem
							button
							key={text}
						>
							<div
								style={{
									fontFamily: 'HelveticaNeue-Bold',
									paddingBottom: 8,
								}}
							>
								{text.toUpperCase()}
							</div>
						</ListItem>
					</NavLink>
				))}
			</List>
			<Fab
				// color="primary"
				aria-label='add'
				variant='extended'
				className={classes.fab}
				style={{ bottom: 80, backgroundColor: 'transparent' }}
				onClick={() => setOpenBannerModal(true)}
			>
				Banner
			</Fab>
			<Fab
				color='primary'
				aria-label='add'
				variant='extended'
				className={classes.fab}
				onClick={() => setOpenBroadcastModal(true)}
			>
				Broadcast
			</Fab>
		</div>
	);

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar
				position='fixed'
				color='transparent'
				className={classes.appBar}
			>
				<Toolbar>
					<IconButton
						style={{ color: BLACK_COLOR }}
						aria-label='open drawer'
						edge='start'
						onClick={handleDrawerToggle}
						className={classes.menuButton}
					>
						<MenuIcon />
					</IconButton>
					<Typography
						variant='h6'
						className={classes.title}
					></Typography>
					<MenuItem>
						<p style={{ fontFamily: 'HelveticaNeue-CondensedBold' }}>
							{props.auth.userData.username.slice(0, 15)}
							{props.auth.userData.username.length > 15 && '...'}
						</p>
						<IconButton
							aria-label='account of current user'
							aria-controls='primary-search-account-menu'
							aria-haspopup='true'
							color='inherit'
						>
							<Avatar
								alt='user avatar'
								src='/static/images/avatar/1.jpg'
								className={classes.large}
							>
								{getNameAbbreviation(props.auth.userData.username)}
							</Avatar>
						</IconButton>
					</MenuItem>
					<Button
						variant='contained'
						onClick={handleLogout}
						color='secondary'
						style={{
							fontFamily: 'HelveticaNeue-CondensedBold',
							borderRadius: 8,
							paddingRight: 25,
							paddingLeft: 25,
						}}
						disableElevation
					>
						LOGOUT
					</Button>
				</Toolbar>
			</AppBar>
			<nav
				className={classes.drawer}
				aria-label='mailbox folders'
			>
				{/* The implementation can be swapped with js to avoid SEO duplication of links. */}
				<Hidden
					smUp
					implementation='css'
				>
					<Drawer
						container={container}
						variant='temporary'
						anchor={theme.direction === 'rtl' ? 'right' : 'left'}
						open={mobileOpen}
						onClose={handleDrawerToggle}
						classes={{
							paper: classes.drawerPaper,
						}}
						ModalProps={{
							keepMounted: true, // Better open performance on mobile.
						}}
					>
						{drawer}
					</Drawer>
				</Hidden>
				<Hidden
					xsDown
					implementation='css'
				>
					<Drawer
						classes={{
							paper: classes.drawerPaper,
						}}
						variant='permanent'
						open
					>
						{drawer}
					</Drawer>
				</Hidden>
			</nav>
			<main className={classes.content}>
				<div className={classes.toolbar} />
				{props.children}
				<AppModal
					open={openBannerModal}
					handleClose={() => setOpenBannerModal(false)}
				>
					<AddBanner handleClose={() => setOpenBannerModal(false)} />
				</AppModal>
				<AppModal
					open={openBroadcastModal}
					handleClose={() => setOpenBroadcastModal(false)}
				>
					<Broadcast handleClose={() => setOpenBroadcastModal(false)} />
				</AppModal>
			</main>
		</div>
	);
}

AppDrawer.propTypes = {
	/**
	 * Injected by the documentation to work in an iframe.
	 * You won't need it on your project.
	 */
	container: PropTypes.any,
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ logout }, dispatch);
};

export default connect(({ auth }) => ({ auth }), mapDispatchToProps)(AppDrawer);
